import { render, staticRenderFns } from "./select-popper.vue?vue&type=template&id=4584281d&"
import script from "./select-popper.vue?vue&type=script&lang=js&"
export * from "./select-popper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports